import { Component } from '@angular/core';
import { IonicApp, NavController, NavParams, ToastController, MenuController, Events } from 'ionic-angular';
import { RegisterPage } from "../register/register";
import { ForgotPasswordPage } from "../forgot-password/forgot-password";
import { HomePage } from "../home/home";
import { Headers, RequestOptions } from '@angular/http';
import { CartManager } from "../../providers/cart-manager";
import { MsgManager } from "../../providers/msg-manager";
import { Settings } from "../../providers/settings";
import { SpinnerDialog } from 'ionic-native';
import { CATEGORIESnTAGS, loginUserInfo, pickPackParams } from "../../providers/data";
import { TokenManager } from "../../providers/token-manager";
import { Constants, isIntelliStock } from "../../providers/config";
import { Storage } from '@ionic/storage';
import { ItemsPage } from '../items/items';
import { GVLogger } from '../../services/gv-logger';
import { Api } from '../../providers/api';
import { selectedLocationTemorary, loggedInUser, ROLE } from "../../providers/data"
import 'rxjs/add/operator/map';
import { IMAGES_BASE_URL, AppConfig } from '../../providers/config';
import { CommonDataProvider } from "../../providers/common-data/common-data";
import { StockcartManager } from '../../providers/stockcart-manager';
import { RoutingInfo } from '../../providers/data';
import { MovestockcartManager } from "../../providers/movestockcart-manager";
import { MyOrderPage } from "../my-order/my-order";
import { WarehousesPage } from "../warehouses/warehouses";
import { WorkOrdersPage } from "../work-orders/work-orders";


@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  constants = Constants;

  isIntelliStockfunc = isIntelliStock;
  // import f1 = module('file1');

  data: any;
  formData: any;
  app: any;
  backGroundImage: string;
  showPassword: boolean = false;

  constructor(public nav: NavController,
    private api: Api,
    private cartManager: CartManager,
    public toastCtrl: ToastController,
    public app1: IonicApp,
    public menuController: MenuController,
    public settings: Settings,
    public events: Events,
    public msgManager: MsgManager,
    private tokenManager: TokenManager,
    public storage: Storage,
    private gVLogger: GVLogger,
    private navParams: NavParams,
    public commonDataProvider: CommonDataProvider,
    private stockCartManager: StockcartManager,
    private movestockcartManager: MovestockcartManager,
    private moveStockCartManager: MovestockcartManager
  ) {

    pickPackParams.params = ""

    if (localStorage.getItem("isLoggedIn") && localStorage.getItem("isLoggedIn") == 'true') {
      this.events.publish('logOutSuccess');
      selectedLocationTemorary.location = 0;
    }

    // throw new Error({'hehe':'haha'});

    CATEGORIESnTAGS.categories = [0];
    CATEGORIESnTAGS.tags = [0];

    this.holdPreviousOrder();
    this.formData = { user: "", pass: "" };
    this.checkLoggedin();
    this.app = app1;
    this.menuController.swipeEnable(false, 'sideMenu');
    this.menuController.swipeEnable(false, 'testRightMenu');
    if (Constants.isWebstore) {
      this.backGroundImage = 'url(' + IMAGES_BASE_URL.imageBaseUrl + "/" + Constants.customerID + "/branding/backDrop.png?v=" + Math.round((new Date()).getTime() / 1000) + ')';
    } else {
      this.backGroundImage = '#2B2B2B';
    }
    this.gVLogger.log(this.backGroundImage);
  }

  // go to register page
  register() {
    this.nav.push(RegisterPage);
  }

  checkLoggedin() {


    this.storage.get("user").then((user) => {
      if (user === null) {

      } else {

        this.settings.setStaySignedIn(false);

        localStorage.removeItem("user");
        this.events.publish('logOutSuccess');
      }
    });

  }

  checkVersion() {

    let body = {
      version: this.constants.version,
      country: this.constants.country,
      app: "Intellistock"
    }
    this.api.postRA("/api/v1/getVersion", body).map(res => res.json()).subscribe(result => {
      this.gVLogger.log("STATAUS" + result.status);
      if (result.status == 200) {
        this.login();

      } else {
        // this.nav.setRoot(this.nav.getActive().component);
        window.location.reload();
      }
    });
  }

  // go to home page
  login() {
    SpinnerDialog.show(this.msgManager.getAuthMsg());
    let appType = "Intellistock";

    let endpoint: string = '/api/v1/users/signin';
    if (Constants.isWebstore) {
      appType = "IntelliCommerce";
      endpoint = '/api/v1/users/webStoreSignin';
    }


    let body: any = { appType: appType };
    body.appType = appType;
    if (Constants.isWebstore) {
      body.uuid = Constants.customerID;
    }

    if (AppConfig.ENVIRONMENT === 'LOCAL') {
      endpoint = 'users/auth';
      body.user = this.formData.user;
      body.pass = this.formData.pass;
    }
    else {
      body.userName = this.formData.user;
      body.password = this.formData.pass;
    }



    this.api.postRA(endpoint, body)
      .map(res => res.json())
      .subscribe(loginRes => {
        if (loginRes.status === 402) {
          let toast = this.toastCtrl.create({
            message: loginRes.message || 'Invalid credentials',
            duration: 3000,
            position: 'top'
          });
          toast.present();
          SpinnerDialog.hide();
          return;
        }
        // loginUserInfo.assignedWarehouseId = loginRes.data.data.assignedWarehouseId;
        // loginUserInfo.assignedWarehouseName = loginRes.data.data.assignedWarehouseName;
        // loginUserInfo.assignedWarehouseType = loginRes.data.data.assignedWarehouseType;
        // loginUserInfo.restrictedToViewOrder = loginRes.data.data.restrictToViewOrder;
        // loginUserInfo.firstName = loginRes.data.data.firstName;
        // loginUserInfo.lastName = loginRes.data.data.lastName;
        // loginUserInfo.customerType = loginRes.data.data.adpCustomerInfo.customerType;
        // loginUserInfo.showInventoryButtonFlag = loginRes.data.data.adpCustomerInfo.showInventoryButtonFlag;
        // loginUserInfo.multiCurrencyFlag = loginRes.data.data.adpCustomerInfo.multiCurrencyFlag;
        // RoutingInfo.dt = loginRes.dtapiUrl;
        // RoutingInfo.rt = loginRes.rtapiUrl;
        // RoutingInfo.imageBaseUrl = loginRes.imagesBaseUrl;
        // IMAGES_BASE_URL.imageBaseUrl = loginRes.imagesBaseUrl;
        // RoutingInfo.billingUrl = loginRes.billingApiUrl;
        // RoutingInfo.jazzbaManageUrl = loginRes.jazzbaManageUrl;
        // RoutingInfo.imageUploaderUrl = loginRes.imageUploderURL;
        // loginUserInfo.countryAbbrivation = loginRes.countryAbbrivation;

        // alert("login")

        // for(let loc of loginRes.data.data.customersDTO.locationsDTOs){
        //   this.gVLogger.log("location dto " + JSON.stringify( loc));
        //   if(loc.locationType === "SHIPTO" || loc.locationType === "BILLTOSHIPTO") {
        //     loginUserInfo.customerShippingCost = loc.shippingCost;
        //   }
        // }


        let data;
        if (loginRes.countryCode !== undefined) {
          this.storage.set('countryCode', loginRes.countryCode);
          localStorage.setItem('countryCode', loginRes.countryCode);
          this.commonDataProvider.countryCode = loginRes.countryCode;

          data = loginRes.data;

        }
        else {
          this.storage.set('countryCode', 0);
          data = loginRes;
        }


        // if(data.status == 200 && data.data.adpCustomerInfo.customerType.toLocaleLowerCase() != "buyer" ){
        if (data.status == 200) {
          this.gVLogger.log("-----if called-----");

          // Success toast
          let toast = this.toastCtrl.create({
            message: 'Login successful!',
            duration: 3000,
            position: 'top'
          });
          toast.present();

          // Move all the data assignment here, after confirming successful login
          loginUserInfo.assignedWarehouseId = loginRes.data.data.assignedWarehouseId;
          loginUserInfo.assignedWarehouseName = loginRes.data.data.assignedWarehouseName;
          loginUserInfo.assignedWarehouseType = loginRes.data.data.assignedWarehouseType;
          loginUserInfo.restrictedToViewOrder = loginRes.data.data.restrictToViewOrder;
          loginUserInfo.firstName = loginRes.data.data.firstName;
          loginUserInfo.lastName = loginRes.data.data.lastName;
          loginUserInfo.customerType = loginRes.data.data.adpCustomerInfo.customerType;
          loginUserInfo.showInventoryButtonFlag = loginRes.data.data.adpCustomerInfo.showInventoryButtonFlag;
          loginUserInfo.multiCurrencyFlag = loginRes.data.data.adpCustomerInfo.multiCurrencyFlag;
          RoutingInfo.dt = loginRes.dtapiUrl;
          RoutingInfo.rt = loginRes.rtapiUrl;
          RoutingInfo.imageBaseUrl = loginRes.imagesBaseUrl;
          IMAGES_BASE_URL.imageBaseUrl = loginRes.imagesBaseUrl;
          RoutingInfo.billingUrl = loginRes.billingApiUrl;
          RoutingInfo.jazzbaManageUrl = loginRes.jazzbaManageUrl;
          RoutingInfo.imageUploaderUrl = loginRes.imageUploderURL;
          loginUserInfo.countryAbbrivation = loginRes.countryAbbrivation;

          // Rest of the success code...
          this.storage.set("userID", data.data.id);
          this.storage.set("userName", this.formData.user);

          loggedInUser.userName = this.formData.user;
          loginUserInfo.id = data.data.id
          console.log("ddddd" + loginUserInfo.id)
          this.storage.set("loginRes", loginRes);

          this.cartManager.setSalesPerson(data.data);
          // this.cartManager.setLoginUserInfo(data.data.userName, data.data.adpCustomerInfo.country);
          this.cartManager.setAdpCustomerInfo(data.data.adpCustomerInfo);
          this.gVLogger.log(data.data);
          this.tokenManager.setToken(data.data.authToken);

          this.api.get("users/getUserByUserName")
            .map(res => res.json())
            .subscribe((results) => {

              if (results.status == "401") { // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                this.nav.setRoot(LoginPage);
              }

              console.log("User data from the seever  :" + results)
              // this.user = results.data;
              this.cartManager.setLoginUserInfo(data.data.userName,
                data.data.adpCustomerInfo.country, results.data.email,
                results.data.firstName, results.data.lastName,
                results.data.password, results.data.phone);

            });

          if (!Constants.isWebstore) {
            // this.imageCacheCheck();
          }
          // WEBSTORE MERGE

          // Only Admins (1) and stock person (5) can enter into intelliStock (Buyers, suppliers, both)
          // Only Admins (1) and sale reps (3) can enter into intellirep (suppliers, both)
          // Only admins (1) can enter into webstore (buyers only)
          if (Constants.isWebstore) { // if webstore login

            // if (data.data.adpCustomerInfo.customerType.toLowerCase() == "buyer" && data.data.roleId == 1 ){

            if (data.data.roleId == 1 || data.data.roleId == 2) { // Only admins (1) can enter into webstore (buyers only)

              this.events.publish('loginSuccess');

              this.cartManager.setCustomer(data.data.customersDTO);
              this.stockCartManager.setCustomer(data.data.customersDTO);
              this.moveStockCartManager.setCustomer(data.data.customersDTO);

              SpinnerDialog.hide();

              if (Constants.isWebstore) {
                this.api.get("global/settings")
                  .subscribe(result => {
                    let res = result.json();
                    this.storage.set("defaultLayout", res.data.browseProductDefaultView);

                    this.nav.setRoot(ItemsPage);
                  }, err => {
                    console.error("webstore elseeeee in set default view-------------------", err);

                    this.nav.setRoot(ItemsPage);
                  });
                this.nav.setRoot(ItemsPage);
              } else {
              }
            }//UD
            else {
              this.msgManager.toastMsg("Sales and admin system users can only login through the tablet app. Thank you.");
              //this.nav.setRoot(HomePage);
              SpinnerDialog.hide();
            }
          } else {
            if (Constants.IntelliStockRunningIn === 'NA') {  // The intelliRep login conditions start here

              if (data.data.roleId === 3 || data.data.roleId === 1) {// Only Admins (1) and sale reps (3) can enter into intellirep (suppliers, both)

                this.events.publish('loginSuccess');

                this.cartManager.setCustomer(data.data.customersDTO);
                this.stockCartManager.setCustomer(data.data.customersDTO);
                this.moveStockCartManager.setCustomer(data.data.customersDTO);

                SpinnerDialog.hide();

                this.storage.get("defaultLayout").then((defaultLayout) => {
                  if (defaultLayout === "list" || defaultLayout === "grid") {
                    //TODO: get layout from Server
                    // this.api.get("global/settings")
                    // .map(res=>res.json())
                    // .subscribe(result=>{
                    //   this.storage.set("defaultLayout",result.data.browseProductDefaultView);
                    // },err=>{
                    //   console.error(err);
                    // })
                    this.nav.setRoot(HomePage);
                  }
                });
                this.api.get("global/settings")
                  .subscribe(result => {
                    let res = result.json();
                    this.storage.set("defaultLayout", res.data.browseProductDefaultView);
                  }, err => {
                    console.error(err);
                  })
                this.nav.setRoot(HomePage);
              } else {
                this.msgManager.toastMsg("Customers can login through webstore only. Thank you.");
                //this.nav.setRoot(HomePage);
                SpinnerDialog.hide();
              }
              // this.gVLogger.log("-------else called------");

            } else {

              this.storage.set("roleId", data.data.roleId);
              console.log("ROLEIDDDDDDD data " + data.data.roleId);

              ROLE.roleId = data.data.roleId;

              //  this.storage.get("roleId").then((data) => {
              //    console.log("ROLEIDDDDDDD " + data);
              //
              // });

              if (data.data.roleId === 5 || data.data.roleId === 1 || data.data.roleId === 3) {

                // Only Admins (1) and stock person (5) can enter into intelliStock (Buyers, suppliers, both)

                this.gVLogger.log("IIIIIIIIIIIIIIStock LOgin")
                this.events.publish('loginSuccess');

                this.cartManager.setCustomer(data.data.customersDTO);
                this.stockCartManager.setCustomer(data.data.customersDTO);
                this.moveStockCartManager.setCustomer(data.data.customersDTO);

                SpinnerDialog.hide();

                this.storage.get("defaultLayout").then((defaultLayout) => {
                  if (defaultLayout === "list" || defaultLayout === "grid") {

                    if (loginUserInfo.assignedWarehouseId === 0) {
                      this.nav.setRoot(WarehousesPage);
                    } else {
                      this.nav.setRoot(WorkOrdersPage);
                    }

                  }
                });
                this.api.get("global/settings")
                  .subscribe(result => {
                    let res = result.json();
                    this.storage.set("defaultLayout", res.data.browseProductDefaultView);
                  }, err => {
                    console.error(err);
                  })
                if (loginUserInfo.assignedWarehouseId === 0) {
                  this.nav.setRoot(WarehousesPage);
                } else {
                  this.nav.setRoot(WorkOrdersPage);
                }
              } else {
                this.msgManager.toastMsg("Customers can login through webstore only. Thank you.");
                //this.nav.setRoot(HomePage);
                SpinnerDialog.hide();
              }
            }

          }

        }
        else if (data.status === 403) {
          SpinnerDialog.hide();
          let toast = this.toastCtrl.create({
            message: data.message || 'Invalid credentials',
            duration: 3000,
            position: 'top'
          });
          toast.present();
        }

        else {
          SpinnerDialog.hide();
          let toast = this.toastCtrl.create({
            message: this.msgManager.getLogingErrorMsg(),
            duration: 3000,
            position: 'top'
          });
          toast.present();
        }
      });

  }

  // go to forgot password page
  forgotPwd() {
    this.nav.push(ForgotPasswordPage);
  }


  holdPreviousOrder() {

    this.gVLogger.log("hold order");
    this.stockCartManager.setLocation("");
    this.stockCartManager.setReference("");
    this.moveStockCartManager.setLocation("");


    if (this.cartManager.getProductsCount()) {
      this.gVLogger.log("start holding");


      var body: any = this.cartManager.genrateOrder(2, loginUserInfo.customerShippingCost); // placeorder status 2


      this.gVLogger.log(JSON.stringify(body));
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });
      //this.saveOrderOnDisk();
      this.api.post("order/place", JSON.stringify(body), options)
        .map(res => res.json())
        .subscribe(resp => {
          if (resp.status == "401") { // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if (resp.status = "200") {
            this.gVLogger.log("Previous Order On hold");

            this.cartManager.setCustomer(null);
            this.cartManager.setItems([]);
            this.cartManager.clearCart();
            this.cartManager.setOrderId(0); // orderid after submission
            this.cartManager.setOrderMessage("");

          }

        }
          , error => {
            //alert(JSON.stringify(error));
          });


    } else {
      this.gVLogger.log("No previous order to hold");

    }

  }

  forgotPassword() {
    this.nav.push(ForgotPasswordPage);
  }


  signup() {
    this.nav.push(RegisterPage);
  }


  imageCacheCheck() {

    let uuid = this.cartManager.getADPCustomerUUID();

    this.gVLogger.log("checking Cache is enabled");
    this.storage.get("cacheImages").then((cacheImages) => {// cache enable flag
      this.storage.get("cacheCompleted" + uuid).then((cacheCompleted) => { //cache completed flag
        if (cacheImages === null && cacheCompleted === null) {
          this.storage.set("cacheImages", true); // enable flag
          this.storage.set("cacheCompleted" + uuid, false); // completed false
          // preload here
          this.settings.preLoadImages();
        } else if (cacheImages === null && !cacheCompleted) {
          this.storage.set("cacheImages", true); // enable flag
          // preload here
          this.settings.preLoadImages();
        } else if (cacheCompleted === null && cacheImages) {
          this.storage.set("cacheCompleted" + uuid, false); // completed false
          // preload here
          this.settings.preLoadImages();
        } else if (cacheImages && !cacheCompleted) {
          // preload here
          this.settings.preLoadImages();
        }
      });

    });
  }



  getBackGroundImage() {
    var backGroundImage = `background-color: #2B2B2B;`;
    if (Constants.isWebstore) {
      backGroundImage = IMAGES_BASE_URL.imageBaseUrl + "/" + Constants.customerID + "/branding/backDrop.png";
      const style = `background: url(${backGroundImage})`;
      return style;
    } else {

      return backGroundImage;
    }

    //return

  }


  getWebstoreLogoURL() {
    return IMAGES_BASE_URL.imageBaseUrl + "/" + Constants.customerID + "/branding/logo.png?v=" + Math.round((new Date()).getTime() / 1000);
  }

  logoImageNotFound(event) {
    event.target.src = IMAGES_BASE_URL + "/jazzba/logos/logo-jazzba.png";
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts